import { IBusinessToolForm } from 'components/BusinessToolForm/utils/form';

export const getCoverPageProps = (businessPlanChapters: IBusinessToolForm) => {
  const { companyName, coverTitle } = businessPlanChapters.GLOBAL;
  const { file } = businessPlanChapters.OVERVIEW.company;

  return {
    name: companyName,
    description: coverTitle,
    logoUrl: file[0]?.url,
  };
};
